var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 7.5C8.433 7.5 10 5.933 10 4C10 2.067 8.433 0.5 6.5 0.5C4.567 0.5 3 2.067 3 4C3 5.933 4.567 7.5 6.5 7.5Z",
    stroke: "#0B112C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13C1 9.96243 3.46243 7.5 6.5 7.5V7.5C9.53757 7.5 12 9.96243 12 13V14.5H1V13Z",
    stroke: "#0B112C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInPerson);
export default __webpack_public_path__ + "static/media/In Person.8bf40ede8d5a9f5e021f2502b0541265.svg";
export { ForwardRef as ReactComponent };